document.addEventListener('alpine:init', () => {
  Alpine.data('CartDrawer', () => ({
    cart: {
      items: [], 
      item_count: 0, 
      total_price: 0
    },
    flags: {
      open: false,
      empty: true,
      enable_recommended_upsells: false,
      discount_code_applied: false
    },
    discount_code: '20OFF',
    recommended_products: [],
    init() {
      this.InitWatchers();
      this.InitSelf();
      this.InitEventHandlers();
    },
    InitSelf() {
      let am = this;
      am.UpdateCart();
      am.flags.enable_recommended_upsells = am.$el.dataset.enable_recommended_upsells == 'true';
    },
    InitWatchers() {
      let am = this;
      am.$watch('flags.open', () => {
        document.body.classList.toggle('is-cart-open', am.flags.open);
      });

      am.$watch('cart', am.UpdateFlags.bind(am));

      let cart_open_events = ['cart:modified', 'cart:drawer:open'];
      cart_open_events.forEach((event_type) => {
        document.addEventListener(event_type, async (e) => {
          // console.log(e);
          await am.UpdateCart();
          am.flags.open = true;
        });  
      })

      UTILS.ObserveMutation('#cart-icon-bubble', {}, async(m) => {
        // console.log('mutation', m);
        await am.UpdateCart();
        am.flags.open = true;
      });

      document.addEventListener('cart:drawer:close', () => {
        am.flags.open = false;
      });
    },
    InitEventHandlers() {
      let am = this;
      let $toggles = [
        ...document.querySelectorAll('#cart-icon-bubble')
      ];
      // console.log($toggles)
      $toggles.forEach(($toggle) => {
        $toggle.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          am.flags.open = true;
        });
      });
    },
    FormatMoney(value) {
      return UTILS.FormatMoney(value);
    },
    UpdateFlags() {
      let am = this;
      am.flags.empty = am.cart.item_count == 0;
      am.flags.discount_code_applied = am.cart.cart_level_discount_applications?.find(item => item.title == am.discount_code) !== undefined;
    },
    async UpdateCart() {
      let am = this;
      let cart = await fetch('/cart.js').then(res => res.json());
      am.cart.items = [];
      am.$nextTick(() => {
        am.cart = {...cart};
        document.dispatchEvent(new CustomEvent('cart:updated', {detail: { cart }}));  
      });
      document.querySelectorAll('[data-cart-count]').forEach(($el) => {
        $el.textContent = cart.item_count;
      });
    },
    async e_UpdateLineQuantity(item) {
      let am = this;
      let item_updates = {}
      item_updates[item.key] = item.quantity;
      // console.log(item, item_updates);
      await UTILS.UpdateCartItems(item_updates);
      am.UpdateCart();
    },
    e_Checkout() {
      window.location.href = '/checkout';
    },
    async e_LoadRecommendedProducts(e) {
      // console.log(e);
      let am = this;
      if (!am.flags.enable_recommended_upsells) return;
      let recommended_products = [...new Set(e.detail.products)];
      recommended_products.forEach((p) => {
        p.variant_first = p.variants.find((v) => v.available);
      });

      let section = 'product-mf';
      let px = Promise.all(recommended_products.map(async (p) => {  
        let p_res = await fetch(`/products/${p.handle}?sections=${section}`).then(res => res.json());
        p.image_1_unit = UTILS.ConvertStringToHTML(p_res[section]).querySelector('[data-product_metafields]').dataset.image_1_unit;
        //commented to remove the overwriting of the default image

        return p;
      }));

      let products = await px;
      am.recommended_products = [...products].slice(0, 2);
    },
    async e_ToggleCoupon() {
      await fetch(`/discount/${this.discount_code}`);
      document.dispatchEvent(new CustomEvent('cart:modified'));
    }
  }));

  Alpine.data('CartProgressBars', () => ({
    pbars: {
      free_product: {
        enabled: true,
        threshold: 4500,
        progress: 0
      },
      free_ship: {
        enabled: true,
        threshold: 10000,
        progress: 0
      }
    },
    init() {
      this.InitSelf();
      this.InitWatchers();
      this.UpdateProgress();
    },
    InitSelf() {
      let am = this;
      am.pbars.free_ship.threshold = parseFloat(am.$el.dataset.freeShipThreshold) * 100;
    },
    InitWatchers() {
      let am = this;
      am.$watch('cart', am.UpdateProgress.bind(am));
    },
    UpdateProgress() {
      let am = this;
      // free shipping logic
      let subscription_items = am.cart.items.filter(item => !!item.selling_plan_allocation);
      let free_ship_progress = subscription_items.length ? 100 : (am.cart.total_price * 100 / am.pbars.free_ship.threshold);
      // console.log(am.pbars.free_ship.progress)
      am.pbars.free_ship.progress = free_ship_progress >= 100 ? 100 : free_ship_progress;
    }
  }));

  Alpine.data('CartLineItem', () => ({
    line_item: null,
    product: {},
    upsell: null,
    cache: {},
    flags: {
      is_onetime: true,
      product_offers_subscription: false,
      is_3pack: false,
      enable_recommended_upsells: false,
      initiate_fetch_recommended_upsells: false
    },
    recommended_products: [],
    init() {
      let am = this;
      am.InitWatchers();
      am.$nextTick(am.InitSelf.bind(am));
    },
    async InitSelf() {
      let am = this;
      am.cache.$cart_drawer = am.$el.closest('.cart_drwr');
      am.line_item = JSON.parse(am.$el.dataset.lineitem);
      am.CheckFlags();
      let product = await fetch(`/products/${am.line_item.handle}.js`).then(res => res.json());
      am.product = {...am.product, ...product};
      // console.log(am.product)

      let section = 'product-mf';
      let p_res = await fetch(`/products/${am.line_item.handle}?sections=${section}`).then(res => res.json());
      // am.product.image = UTILS.ConvertStringToHTML(p_res[section]).querySelector('[data-product_metafields]').dataset.image_1_unit;
      //commented to remove the overwriting of the default image

       let variant = am.product.variants.find(v => v.id == am.line_item.id);
      am.product.curr_variant_compareprice=variant.compare_at_price;

      // console.log(p_res, am.product)
    },
    InitWatchers() {
      let am = this;
      am.$watch('product', () => {
        am.CheckFlags();
        am.CheckUpsells();
        if (!am.flags.initiate_fetch_recommended_upsells && am.recommended_products.length == 0) {
          am.flags.initiate_fetch_recommended_upsells = true;
          am.GetRecommendedProducts();
        }
      });
    },
    CheckFlags() {
      let am = this;
      if (am.product && am.product.selling_plan_groups) {
        am.flags.product_offers_subscription = am.product.selling_plan_groups.length !== 0;
        am.flags.is_onetime = am.flags.product_offers_subscription && !am.line_item.selling_plan_allocation;  
      }
      am.flags.is_3pack = am.line_item.title.indexOf('3 Pack') !== -1;
      am.flags.enable_recommended_upsells = am.cache.$cart_drawer.dataset.enable_recommended_upsells == 'true';
    },
    CheckUpsells() {
      let am = this;
      let upsell;
      let variant = am.product.variants.find(v => v.id == am.line_item.id);
      let pack_type = variant.option1.toLowerCase();
      /* 
        // Upsell logic 
        // If One-time - upsell same variant subscription
        // If subscription and not 3-pack - upsell 3-pack variant subscription
      */
      
        if (am.flags.is_onetime) {
          upsell = variant;
          upsell.selling_plan = variant.selling_plan_allocations[0];
        }
        else {
          if (pack_type !== '3 pack') {
          let variant_3pack = am.product.variants.find(v => v.option1 == '3 Pack');
          upsell = variant_3pack;
          upsell.selling_plan = variant_3pack.selling_plan_allocations[0];
        }
      }
      am.upsell = upsell;
    },
    async e_AddUpsell() {
      let am = this,
        line_item = am.line_item, 
        upsell = am.upsell;
      // If upsell is same as current variant, add subscription
      if (line_item.id == upsell.id) {
        let item_updates = {
          id: line_item.key,
          quantity: line_item.quantity,
          selling_plan: upsell.selling_plan.selling_plan_id,  
        };
        await UTILS.UpdateCartItem(item_updates);
        document.dispatchEvent(new CustomEvent('cart:modified'));  
      }
      // If upsell is not same as current variant, replace variant with new variant & subscription
      if (line_item.id !== upsell.id) {
        // remove existing item
        let item_remove = {
          id: line_item.key,
          quantity: 0
        };
        await UTILS.UpdateCartItem(item_remove);

        // new item to add
        let items_to_add = [{
          id: upsell.id,
          quantity: 1,
          selling_plan: upsell.selling_plan.selling_plan_id
        }];
        await UTILS.AddItemsToCart(items_to_add);
        document.dispatchEvent(new CustomEvent('cart:modified'));  
      }
    },
    async e_Revert_OneTime() {
      let am = this,
        line_item = am.line_item;
      let item_updates = {
        id: line_item.key,
        quantity: line_item.quantity,
        selling_plan: null
      };
      await UTILS.UpdateCartItem(item_updates);
      document.dispatchEvent(new CustomEvent('cart:modified'));
    },
    async e_Revert_Monthly() {
      let am = this,
        line_item = am.line_item;

      let item_remove = {
        id: line_item.key,
        quantity: 0
      };
      await UTILS.UpdateCartItem(item_remove);

      let variant_1pack = am.product.variants.find(v => v.option1 == '1 Pack');
      let selling_plan_1pack = variant_1pack.selling_plan_allocations[0];
      let items_to_add = [{
        id: variant_1pack.id,
        quantity: line_item.quantity,
        selling_plan: selling_plan_1pack.selling_plan_id
      }];
      await UTILS.AddItemsToCart(items_to_add);
      document.dispatchEvent(new CustomEvent('cart:modified'));
    },
    async GetRecommendedProducts() {
      let am = this;
      if (!am.flags.enable_recommended_upsells) return;
      
      await fetch(window.Shopify.routes.root + `recommendations/products.json?product_id=${am.product.id}&limit=4&intent=related`)
      .then(response => response.json())
      .then(({ products }) => {
        products = products.filter(p => p.available);
        products = products.filter(p => am.cart.items.map(item => item.id).indexOf(p.id) == -1);
        am.recommended_products = [...products];
        am.$dispatch('cart-recommended-products-loaded', { products });
      });
    }
  }));

  Alpine.data('RecommendedProducts', () => ({
    init() {
      let am = this;
      am.InitSelf();
    },
    InitSelf() {
      let am = this;
      // am.swiper = new Swiper(am.$el, {
      //   slidesPerView: 1.25,
      //   spaceBetween: 10,
      //   grabCursor: true,
      //   pagination: {
      //     el: '.swiper-pagination',
      //     clickable: true
      //   },
      // });
    },
    async e_AddUpsell(e) {
      // console.log(e);
      let am = this;
      let variant = am.product.variants.find(v => v.available);
      let add_item = {
        id: variant.id,
        quantity: 1,
        selling_plan: variant.selling_plan_allocations[0].selling_plan_id
      };
      await UTILS.AddItemsToCart([add_item]);
      document.dispatchEvent(new CustomEvent('cart:modified'));  
    }
  }));
});